import { Component, input, output } from '@angular/core';
import { ButtonSizes, ButtonStyles } from '../../../../button/button.component';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';

@Component({
  selector: 'ziro-service-tile-delete',
  templateUrl: './service-tile-delete.component.html',
  standalone: false,
})
export class ZiroServiceTileDeleteComponent {
  readonly serviceName = input<string>();
  readonly description = input<string>();
  readonly isDeleting = input(false);

  readonly confirmButtonClicked = output();
  readonly cancelButtonClicked = output();

  buttonStyles = ButtonStyles;
  buttonSizes = ButtonSizes;
  ziroIcons = ZiroIcons;

  onCancelClicked(): void {
    this.cancelButtonClicked.emit();
  }

  onConfirmClicked(): void {
    this.confirmButtonClicked.emit();
  }
}
